<h2>Plate Search</h2>
<fieldset>
    <div class="row">
        <div class="col-sm-4 mvd_form-group">
            <label>Plate Number</label>
            <div class="search--input">
                <input class="mvd_form-control autocomplete" id="search" type="text" placeholder="Search by: Number" autocomplete="off" (keyup.enter)="plateSearchClicked()" [(ngModel)]="plateSearchString" />
                <button class="search__icon" title="Search" type="button" (click)="plateSearchClicked()"></button>
            </div>
        </div>
        <div class="col-sm-4 mvd_form-group">
            <label>Exact Match</label>
            <input [(ngModel)]="isExactMatch" [ngModelOptions]="{standalone: true}" name="isExactMatch" type="checkbox" />
        </div>
    </div>
</fieldset>

<div class="well__footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="resetSearch();">Reset</button>
    </div>
</div>

<div class="row">
    <div class="col-12 mvd_form-group" *ngIf="manualUnReserveMessage">
        <label class="mvd_alert--label">{{manualUnReserveMessage}}</label>
        <button class="btn--primary" type="submit" (click)="unreserve()" *ngIf="canManualUnReserve">UnReserve</button>
    </div>
</div>

<ng-container *ngIf="!manualUnReserveMessage && results.length > 0 && results.length < 50">
    <h2>Plate Results ({{ results.length }})</h2>
    <p-table #dt
             class="search__individual"
             [value]="results"
             [rows]="10"
             [paginator]="true"
             [globalFilterFields]="['plateNumber','plateType','vin','vehicleOwnershipPlateStatusTypeId','year','make','model','registrationEndDate']">
        <ng-template pTemplate="caption">
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="8">
                    No records found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th [pSortableColumn]="'plateNumber'">Plate Number<p-sortIcon [field]="'plateNumber'"></p-sortIcon></th>
                <th [pSortableColumn]="'plateType'">Plate Type<p-sortIcon [field]="'plateType'"></p-sortIcon></th>
                <th class="w--vin" [pSortableColumn]="'vin'">Vin<p-sortIcon [field]="'vin'"></p-sortIcon></th>
                <th [pSortableColumn]="'vehicleOwnershipPlateStatusTypeId'">Registration Plate Status<p-sortIcon [field]="'vehicleOwnershipPlateStatusTypeId'"></p-sortIcon></th>
                <th class="w--actions" [pSortableColumn]="'year'">Year<p-sortIcon [field]="'year'"></p-sortIcon></th>
                <th [pSortableColumn]="'make'">Make<p-sortIcon [field]="'make'"></p-sortIcon></th>
                <th [pSortableColumn]="'model'">Model<p-sortIcon [field]="'model'"></p-sortIcon></th>
                <th class="w--date" [pSortableColumn]="'registrationEndDate'">Registration End Date<p-sortIcon [field]="'registrationEndDate'"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr [pSelectableRow]="data">
                <td><a href="javascript:void(0);" (click)="onPlateNumberClicked(data.vehicleOwnershipId);">{{ data.plateNumber }}</a></td>
                <td>{{data.plateType}}</td>
                <td>{{data.vin}}</td>
                <td>{{ data.vehicleOwnershipPlateStatusTypeId | displayValue:vehicleOwnershipPlateStatusTypes }}</td>
                <td>{{data.year}}</td>
                <td>{{data.make}}</td>
                <td>{{data.model}}</td>
                <td>{{data.registrationEndDate | shortDate}}</td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>

<h2 class="mvd_alert--label" *ngIf="!manualUnReserveMessage && hasSearched && results.length == 0">
    No Results
</h2>
<h2 class="mvd_alert--label" *ngIf="results.length >= 50">
    Over 50 results were found.
    <br />
    Additional search criteria is required to continue.
</h2>

